import { types } from 'mobx-state-tree'
import { ConvertableDate } from 'store/types/date'

import { Trigger } from '../trigger'

export const BalanceRecord = types
  .model('BalanceRecordModel', {
    id: types.identifierNumber,
    type: types.string,
    amount: types.number,
    time: ConvertableDate,
    trigger: types.reference(Trigger),
  })
  .preProcessSnapshot((snapshot) => ({
    ...snapshot,
  }))
